function accordianToggle(target,operation) {
    console.log('e.target',target)
       if(operation === 'open') {
         target.setAttribute('data-accordian-active','true')
            const accordianDetails =  document.querySelector(`[data-accordian-details=${target.getAttribute('data-accordian-summary')}]`)
          accordianDetails.style.opacity = '1';
          accordianDetails.style.visiblity = 'visible';
          accordianDetails.style.height = accordianDetails.scrollHeight + "px";
       }
       else {
         target.setAttribute('data-accordian-active','false')
            const accordianDetails =  document
          .querySelector(`[data-accordian-details=${target.getAttribute('data-accordian-summary')}]`)
          accordianDetails.style.opacity = '0';
          accordianDetails.style.visiblity = 'hidden';
          accordianDetails.style.height = "0px";
       }
}

const accordianActions = (e, accordian) => {
    e.stopPropagation();
    if (e.target.hasAttribute('data-accordian-summary')) {
        console.log('accordian', accordian[0].firstElementChild);
        let currentActiveAccordian = null
        accordian.forEach(element => {
            if(element.firstElementChild.getAttribute('data-accordian-active') === 'true') {
                currentActiveAccordian = element.firstElementChild
            }
        })
        // console.log('current active accordian', currentActiveAccordian);
        currentActiveAccordian && (currentActiveAccordian != e.target) && accordianToggle(currentActiveAccordian, 'close')
        if(e.target.getAttribute('data-accordian-active') === 'true') {
        // console.log('inside if condition');
        accordianToggle(e.target, 'close')
      }
      else {
        // console.log('inside else condition')
        accordianToggle(e.target, 'open')
      }
        }
}


const accordian = () => {
    // console.log('accordian called');
    const accordianDiv = [];
    const accordianParent = [...document.querySelectorAll('[data-accordian-container]')]
    accordianParent.forEach(element => {
        accordianDiv.push(...element.querySelectorAll('[data-accordian]'))
    })
    
    // console.log('accordian div', accordianDiv);
    accordianDiv.forEach(element => {
      element.addEventListener('click', function(e) {
        accordianActions(e, accordianDiv)
       })
    })
    
}

export {accordian, accordianActions};